<main class="register-page">
  <section class="register-card">
    <a class="brand" routerLink="/login">
      <img class="brand-logo" src="/brand/logo-horizontal.png" alt="ZepBazaar" />
      <strong>Business Onboarding</strong>
    </a>

    <div class="heading">
      <p>New business application</p>
      <h1>{{ isPasswordStep ? 'Create your password' : 'Onboard your business' }}</h1>
    </div>

    @if (isPasswordStep) {
      <section class="email-sent">
        <span class="material-symbols-outlined">mark_email_read</span>
        <div><strong>{{ statusMessage || 'Check your email' }}</strong><p>Enter the six-digit code sent to {{ business.email }}, then create your password.</p></div>
      </section>
    }
    <form class="register-form" (ngSubmit)="onSubmit()">
      @if (!isPasswordStep) {
      <label>
        <span>Business name</span>
        <input name="name" [(ngModel)]="business.name" placeholder="Business name" required [disabled]="isSubmitting" />
      </label>

      <label>
        <span>Owner name</span>
        <input name="ownerName" [(ngModel)]="business.ownerName" placeholder="Owner name" required [disabled]="isSubmitting" />
      </label>

      <label>
        <span>Work email</span>
        <input type="email" name="email" [(ngModel)]="business.email" placeholder="owner@business.in" required [disabled]="isSubmitting" />
      </label>

      <label>
        <span>Phone</span>
        <input name="phone" [(ngModel)]="business.phone" inputmode="numeric" maxlength="10" pattern="[6-9][0-9]{9}" placeholder="10-digit mobile number" required [disabled]="isSubmitting" (input)="sanitizePhone()" />
      </label>
      } @else {
      <label>
        <span>Verified business email</span>
        <input type="email" name="verifiedEmail" [(ngModel)]="business.email" readonly />
      </label>
      <label>
        <span>Email verification code</span>
        <input name="otp" [(ngModel)]="business.otp" inputmode="numeric" autocomplete="one-time-code" maxlength="6" pattern="[0-9]{6}" placeholder="6-digit code" required [disabled]="isSubmitting" />
      </label>
      <label>
        <span>Create password</span>
        <input type="password" name="password" [(ngModel)]="business.password" minlength="8" placeholder="Create password" required [disabled]="isSubmitting" />
      </label>
      <label>
        <span>Confirm password</span>
        <input type="password" name="confirmPassword" [(ngModel)]="business.confirmPassword" minlength="8" placeholder="Confirm password" required [disabled]="isSubmitting" />
      </label>
      }

      @if (errorMessage) {
        <p class="form-error">{{ errorMessage }}</p>
      }

      <button class="primary" type="submit" [disabled]="isSubmitting">
        <span class="material-symbols-outlined" aria-hidden="true">storefront</span>
        {{ isSubmitting ? 'Please wait...' : (isPasswordStep ? 'Verify & create password' : 'Verify email to continue') }}
      </button>
      @if (isPasswordStep) {
        <button class="secondary" type="button" [disabled]="isSubmitting" (click)="changeEmail()">Change email</button>
      }
    </form>

    <p class="switch"><a routerLink="/login">Back to business sign in</a></p>
  </section>
</main>
